// extracted by mini-css-extract-plugin
export default {"loginMain":"Login_loginMain__tTbVe","kitchenlogo":"Login_kitchenlogo__FGhaX","logo":"Login_logo__nCvFR","form":"Login_form__uXplm"};